import React from 'react';
const features = [{
  icon: '📊',
  title: 'Sistema de Reportes Mensuales',
  desc: 'El padre ve el progreso por escrito cada mes. Las quejas desaparecen. La renovación se vuelve automática.'
}, {
  icon: '💬',
  title: 'Protocolo de Autoridad con Padres',
  desc: 'Scripts exactos para las 7 preguntas difíciles. Nunca más te quedás sin respuesta.'
}, {
  icon: '📱',
  title: 'Scripts de WhatsApp Profesionales',
  desc: '8 mensajes listos para bienvenida, recordatorio, cobranza, referidos y cierre de ciclo.'
}, {
  icon: '📣',
  title: 'Marketing para Llenar Carriles',
  desc: 'Estrategia de redes sociales + Clase Abierta + Sistema de Referidos activado.'
}, {
  icon: '💰',
  title: 'Estructura de Precios por Niveles',
  desc: 'Cómo cobrar entre un 20% y un 30% más sin perder alumnos. Con justificación incluida.'
}, {
  icon: '👥',
  title: 'Sistema de Delegación',
  desc: 'Cómo incorporar ayudantes que ejecuten el Megapack con tu estándar. El sistema crece sin vos.'
}];
export function EliteSection() {
  return <section className="w-full bg-[#0A0A0F] py-16 px-4" data-id="element-27">
      <div className="max-w-4xl mx-auto" data-id="element-28">
        <div className="text-center mb-8" data-id="element-29">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-30">
            ¿Qué agrega el{' '}
            <span className="text-[#FF6B00]" data-id="element-31">Natación Business Pro?</span>
          </h2>
          <p className="text-[#B0B0C0] text-base max-w-xl mx-auto" data-id="element-32">
            Todo lo que necesitás para cobrar lo que tu trabajo vale.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-33">
          {features.map(f => <div key={f.title} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl p-4 flex items-start gap-3" data-id="element-34">
              <span className="text-2xl flex-shrink-0" data-id="element-35">{f.icon}</span>
              <div data-id="element-36">
                <h4 className="text-white font-bold text-sm" data-id="element-37">{f.title}</h4>
                <p className="text-[#B0B0C0] text-sm mt-0.5" data-id="element-38">{f.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}